import Vue from 'vue'
import router, { constantRoutes } from './router'
import store from './store'

const whiteList = ['/login']

/** 拼接父级与相对 path，得到绝对路径（与动态菜单子路由 path 多为相对段一致） */
const joinRoutePath = (basePath, path) => {
  const p = String(path || '').trim()
  if (!p) return (basePath || '').replace(/\/+/g, '/') || ''
  if (p.startsWith('/')) return p.replace(/\/+/g, '/')
  const base = (basePath || '').replace(/\/+$/, '')
  const joined = `${base}/${p}`.replace(/\/+/g, '/')
  return joined.startsWith('/') ? joined : `/${joined}`
}

/**
 * 从动态路由树解析第一个可导航的绝对路径（深度优先，跳过 hidden）
 * 旧版仅看第一层子节点，遇 path 为 '' 或多级嵌套时易得到错误/空串，导致停留在无匹配的 `/` 白屏
 */
const getFirstRoutePath = (routes, basePath = '') => {
  if (!Array.isArray(routes) || routes.length === 0) return ''
  for (const route of routes) {
    if (!route || route.hidden) continue
    if (typeof route.redirect === 'string' && route.redirect) {
      return route.redirect.replace(/\/+/g, '/')
    }
    const fullPath = joinRoutePath(basePath, route.path)
    if (route.children && route.children.length > 0) {
      const deep = getFirstRoutePath(route.children, fullPath)
      if (deep) return deep
      if (fullPath) return fullPath
      continue
    }
    if (fullPath) return fullPath
  }
  return ''
}

router.beforeEach(async (to, from, next) => {
  const token = store.getters['user/token'] || store.state.user.token
  if (token) {
    if (to.path === '/login') {
      const hasLoaded = store.state.permission.addRoutes.length > 0
      if (hasLoaded) {
        const firstPath = getFirstRoutePath(store.state.permission.addRoutes)
        if (firstPath) {
          next({ path: firstPath, replace: true })
          return
        }
      }
      // 动态路由尚未注入：先进入 `/`，走下方「生成路由」分支（常量路由里没有 `/`，必须立刻生成并重定向）
      next({ path: '/', replace: true })
      return
    }

    const hasRoutes = store.state.permission.addRoutes.length > 0
    if (!hasRoutes) {
      const menus = store.getters['user/menus'] || store.state.user.menus || []
      const accessRoutes = await store.dispatch('permission/generateRoutes', menus)
      if (!accessRoutes || accessRoutes.length === 0) {
        await store.dispatch('user/resetToken')
        next(`/login?redirect=${to.fullPath}`)
        return
      }
      router.addRoutes(accessRoutes)
      router.options.routes = constantRoutes.concat(accessRoutes)
      await Vue.nextTick()
      const firstPath = getFirstRoutePath(accessRoutes)
      if (!firstPath) {
        await store.dispatch('user/resetToken')
        next(`/login?redirect=${to.fullPath}`)
        return
      }
      if (to.path === '/') {
        next({ path: firstPath, replace: true })
      } else {
        next({ ...to, replace: true })
      }
      return
    }

    // 动态路由已在内存中注册，但常量路由没有 `/`，直接进入 `/` 会无匹配 → 白屏
    if (to.path === '/' || to.path === '') {
      const firstPath = getFirstRoutePath(store.state.permission.addRoutes)
      if (firstPath) {
        next({ path: firstPath, replace: true })
        return
      }
      await store.dispatch('user/resetToken')
      next(`/login?redirect=${encodeURIComponent(to.fullPath || '/')}`)
      return
    }
    next()
  } else {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next(`/login?redirect=${to.fullPath}`)
    }
  }
})
